import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';

require.ensure([], () => {  
    require('./ListPill.less');
    require('./Material-Design-Iconic.less');
});

class NoDeleteModal extends React.Component {

    constructor(props, context) {
        super(props, context);
    }
    // EVENT HANDLERS

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === "Enter") {
            this.props.close();
        }
        keyEvent.stopPropagation();
    }

    handleKeyUp = (keyEvent) => {
        if (keyEvent.key === "Escape") {
            this.props.close();
        }
        keyEvent.stopPropagation();
    }

    // RENDER METHOD

    render = () => {
        return (
             <Modal show={true} onKeyPress={this.handleKeyPress} onKeyUp={this.handleKeyUp} onRequestHide={() =>{}} className="modal fade" id="myModal3" tabIndex="-1" role="dialog" aria-labelledby="myModal3Label" aria-hidden="true">
                <div className="modal-dialog new-log-entry">
                    <div className="modal-header">
                        <h5 className="modal-title" style={{wordWrap : "break-word"}}>Unable to delete</h5>
                    </div>
                    <div className="modal-body">
                        Selected floating task {this.props.name} could not be deleted as it has log entries associated with it.
                    </div>
                    <div className="modal-footer">
                        <button ref="closeButton" type="button" className="btn btn-default btn-large" onClick={this.props.close}>Close</button>
                    </div>
                </div>
             </Modal>
        );
    }
}

NoDeleteModal.propTypes = {
    close: PropTypes.func,
    name: PropTypes.string
};

export default connect()(NoDeleteModal);



/** WEBPACK FOOTER **
 ** ./src/app/components/NoDeleteModal.js
 **/